import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import H5 from "../../components/Typography/H5";
import ImageUploader from "../../components/ImageUpload";
import { useFetchApi } from "../../hooks/useFetchApi";
import TextFieldWithLabel from "../../components/TextFieldWithLabel";
import Dropdown from "../../components/Dropdown";
import Caption from "../../components/Typography/Caption";

const AdManagementModal: React.FC<{
  status: boolean;
  onClose: Function;
  ad: any;
}> = ({ status, onClose, ad }): React.ReactElement => {
  console.log("ad", ad);
  const [selectedImage, setSelectedImage] = useState<any>();
  const [url, setUrl] = useState<string>("");
  const [section, setSection] = useState<string>("");
  const [order, setOrder] = useState<any>("");

  const { execute } = useFetchApi(
    "/api/ads",
    {},
    ad && ad.id ? "PUT" : "POST",
    onClose
  );

  const handleSubmit = () => {
    const formData = new FormData();
    if (ad && ad.id) {
      formData.append("id", ad.id);
    }
    if (selectedImage) {
      formData.append("file", selectedImage);
    }
    formData.append("url", url);
    formData.append("section", section);
    // formData.append("order_no", order);
    execute(formData, { "Content-Type": "multipart/form-data" });
  };

  const handleChange = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;

    if (id === "url") {
      setUrl(value);
    }

    if (id === "order") {
      setOrder(value);
    }

    if (id === "section") {
      setSection(value);
    }

    console.log("section", section);
  };

  useEffect(() => {
    if (ad && Object.keys(ad).length) {
      setUrl(ad.url);
      setOrder(ad.order_no);
      setSection(ad.section);
    } else {
      setUrl("");
      setOrder("");
      setSection("");
    }
  }, [ad]);

  const sectionOptions = {
    "fundamental-analysis": "Fundamental Anaylsis",
    "screener": "Screener",
    "ai-recommendation": "AI Recommendation",
    "watchlist":"Watchlist"
  };

  return (
    <Modal
      status={status}
      onClose={onClose}
      size="small"
      onSubmit={handleSubmit}
    >
      <TextFieldWithLabel
        textFieldProps={{ required: true }}
        value={url}
        onChange={handleChange}
        id="url"
        label="URL"
      />

      <div className="flex flex-col w-full my-2">
        <Caption>Section</Caption>
        <select
          onChange={handleChange}
          id="section"
          className="border-2 text-blueishblack rounded p-3"
          value={section}
        >
          <option value="">Select Section</option>
          {Object.entries(sectionOptions).map(([key, value]) => (
            <option selected={section === key ? true : false} value={key}>
              {value}
            </option>
          ))}
        </select>
      </div>

      {/* <TextFieldWithLabel textFieldProps={{required: true}} value={order} onChange={handleChange} id="order" label="Order"/> */}
      {/* <div className="flex flex-col w-full my-2">
        <Caption>Order</Caption>
        <select
          onChange={handleChange}
          id="order"
          className="border-2 text-blueishblack rounded p-3"
        >
          <option value="">select order</option>
          {[1, 2, 3].map((a: number) => (
            <option selected={order === a ? true : false} value={a}>
              {a}
            </option>
          ))}
        </select>
      </div> */}
      <ImageUploader
        onUpload={(file: any) => setSelectedImage(file)}
        file={ad}
      />
    </Modal>
  );
};

export default AdManagementModal;
